(function () {
  const ADD_SELECTOR = '.gift-box-block__add';
  const NOTE_SELECTOR = '[data-gift-box-note]';
  const DEBOUNCE_MS = 500;
  let noteTimer;

  function getCartUrl() {
    const el = document.querySelector('[data-gift-box-cart-url]');
    return el ? el.dataset.giftBoxCartUrl : '/cart';
  }

  function openCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    const icon = document.getElementById('cart-icon-bubble');
    if (icon) icon.click();
  }

  function refreshCartIconCount() {
    return fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        const countEl = document.querySelector('.cart-count-bubble [aria-hidden="true"]');
        if (countEl) countEl.textContent = cart.item_count;
      })
      .catch(() => {});
  }

  function refreshCartDrawer() {
    const cartUrl = getCartUrl();
    return fetch(`${cartUrl}?section_id=cart-drawer`)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        ['cart-drawer-items', '.cart-drawer__footer'].forEach((selector) => {
          const target = document.querySelector(selector);
          const source = doc.querySelector(selector);
          if (target && source) target.replaceWith(source);
        });
        const drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.classList.remove('is-empty');
      });
  }

  function setError(message) {
    const errorEl = document.querySelector('[data-gift-box-error]');
    if (!errorEl) return;
    if (message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    } else {
      errorEl.hidden = true;
    }
  }

  function addGiftBox(button) {
    const variantId = button.dataset.variantId;
    button.disabled = true;
    setError('');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then((r) => {
        if (!r.ok) return r.json().then((err) => Promise.reject(err));
        return r.json();
      })
      .then(() => Promise.all([refreshCartDrawer(), refreshCartIconCount()]))
      .then(() => openCartDrawer())
      .catch((err) => {
        setError((err && err.description) || 'Could not add the Gift Box. Please try again.');
      })
      .finally(() => {
        button.disabled = false;
      });
  }

  function updateGiftNote(textarea) {
    const line = textarea.dataset.line;
    const value = textarea.value;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, properties: { 'Gift Note': value } }),
    }).catch(() => {});
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest(ADD_SELECTOR);
    if (button) addGiftBox(button);
  });

  document.addEventListener('input', (event) => {
    const textarea = event.target.closest(NOTE_SELECTOR);
    if (!textarea) return;

    const counter = textarea.parentElement.querySelector('[data-gift-box-counter]');
    if (counter) counter.textContent = textarea.value.length;

    clearTimeout(noteTimer);
    noteTimer = setTimeout(() => updateGiftNote(textarea), DEBOUNCE_MS);
  });
})();
